var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.262,
    y: 18.309,
    width: 25,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(-45 .262 18.309)",
    fill: "#050E27"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.322,
    y: 0.631,
    width: 25,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(45 1.322 .63)",
    fill: "#050E27"
  })));
}
export default SvgClose;